<!--Vista para mostrar un preview del evento que se esta creand o editando
    (ESTA FUNCIONALIDAD ES UNA IDEA DE DESARROLLO A FUTURO, NO ESTA TERMINADA)
-->
<template>
    <v-container fluid class="pa-0 grey lighten-3">
        <v-row justify="center" class="mb-5">
            <v-col cols="12" class="py-0">

                <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->
                 <v-row justify="center" align="center" class="pa-0 mb-5 pos-relative banner-container">
                    <v-img :src="currentEvent.eventImage" lazy-src="https://picsum.photos/id/11/10/6" class="banner-img"></v-img>
                    <v-col cols="12" sm="11" md="8" xl="6" class="banner-content text-center white pa-5 elevation-3">
                        <v-row justify="center" align="center" class="fill-height">
                            <v-col cols="12" class="pb-0">
                                <h1 class="display-2 font-weight-bold">{{ currentEvent.name }}</h1>
                                <v-avatar size="80" class="my-5">
                                    <img :src="user.profilePicture" alt="avatar">
                                </v-avatar>
                                <h2 class="display-1">{{ user.companyName }}</h2>
                            </v-col>
                            <v-col cols="12" class="pb-0 mx-5">
                                <v-divider class="mt-2 mb-3"></v-divider>
                            </v-col>
                            <v-col v-for="(item, index) in socialMediaItems" :key="index" cols="4" sm="3">
                                <v-row justify="center">
                                    <v-icon color="primary" v-bind:style="getSize">
                                        {{ item.icon }}
                                    </v-icon>
                                </v-row>
                                <h4 class="subtitle-1 text-capitalize font-weight-light">{{ item.name }}</h4>
                            </v-col>
                            <v-col v-if="currentEvent.contactDetails.website!=''" cols="4" sm="3">
                                <v-row justify="center">
                                    <v-icon color="primary" v-bind:style="getSize">
                                        {{ contactDetailsIcons.webSite }}
                                    </v-icon>
                                </v-row>
                                <h4 class="subtitle-1 font-weight-light">Sitio Web Oficial</h4>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->

                <v-row justify="center" class="event-content mb-10">
                    <v-col cols="10" md="10" class="elevation-3 white pb-0">

                        <v-row justify="center" class="py-10" data-aos="zoom-in" data-aos-duration="400">
                            <v-col cols="11" sm="10">
                                <h1 class="display-2 font-weight-bold">
                                    Detalles generales del evento
                                </h1>
                            </v-col>

                            <!-- ETIQUETAS DEL EVENTO -->
                            <v-col cols="11" sm="10" data-aos="zoom-in" data-aos-duration="400">
                                <v-chip v-for="amenity in currentEvent.amenities" :key="amenity.id" class="pa-4 ma-2" color="secondary" dark>
                                    <v-avatar left>
                                        <v-icon v-bind:style="getSmallSize">{{ amenities[amenity] }}</v-icon>
                                    </v-avatar>
                                    {{ amenity }}
                                </v-chip>
                            </v-col>
                            <!-- ETIQUETAS DEL EVENTO -->

                            <!-- NOMBRE, LUGAR Y CONTACTO -->
                            <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                                <h1 class="headline font-weight-bold">Nombre del evento</h1>
                                <p>{{ currentEvent.name }}</p>
                            </v-col>
                            <v-col v-if="currentEvent.modality=='ON_SITE'" cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                                <h1 class="headline font-weight-bold">Lugar</h1>
                                <p>{{ currentEvent.address.name }}</p>
                            </v-col>
                            <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400" v-if="currentEvent.contactDetails.tel!='' || currentEvent.contactDetails.email!=''">
                                <h1 class="headline font-weight-bold">Datos de contacto</h1>
                                <p v-for="(item, index) in contactDetailsItems" :key="index">
                                    <v-icon color="accent" left v-bind:style="getSmallSize">{{ item.icon }}</v-icon>
                                    {{ item.value }}
                                </p>
                            </v-col>
                            <!-- NOMBRE Y CONTACTO -->

                             <!-- FECHA Y HORA DEL EVENTO -->
                            <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                                <h1 class="headline font-weight-bold">Fecha y hora</h1>
                                <p v-if="currentEvent.startDate!='' && currentEvent.startDate==currentEvent.endDate">
                                    El día {{ currentEvent.startDate | date }} de {{ currentEvent.startTime }} a {{ currentEvent.endTime }}.
                                </p>
                                <p v-else>
                                    Del día {{ currentEvent.startDate | date }} al día {{ currentEvent.endDate | date }} de {{ currentEvent.startTime }} a {{ currentEvent.endTime }}.
                                </p>
                            </v-col>
                            <!-- FECHA Y HORA DEL EVENTO -->

                            <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->
                            <v-col v-if="currentEvent.details!=''" cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                               <span ref="customContent" class="event-custom-content" v-html="currentEvent.details"></span>
                            </v-col>
                            <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->

                             <!-- PUBLICIDAD DEL EVENTO -->
                            <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                                <h1 class="headline font-weight-bold mb-3">
                                  Publicidad
                                </h1>
                                <p>
                                    Ve la imagen del evento -
                                    <image-card v-bind:img="currentEvent.eventImage"></image-card>
                                </p>
                            </v-col>
                            <!-- PUBLICIDAD DEL EVENTO -->

                            <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
                            <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400" v-if="currentEvent.faqs[0].question!=''">
                                <h1 class="headline font-weight-bold mb-3">
                                    Preguntas frecuentes
                                </h1>
                                <faq-panel :questions="currentEvent.faqs"></faq-panel>
                            </v-col>
                            <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
                        </v-row>

                        <v-row justify="center"  class="text-center pb-10 mb-10">
                            <!-- VIDEO DEL EVENTO -->
                            <v-col v-if="currentEvent.socialMedia.youtube" cols="10" sm="5" lg="5" style="flex-wrap:wrap" class="mb-5 mb-md-0" data-aos="fade-right" data-aos-duration="400">
                                <h1 class="headline font-weight-bold mb-5 text-uppercase">
                                    Video publicitario
                                </h1>
                                <video-card :video="currentEvent.socialMedia.youtube"></video-card>
                            </v-col>
                            <!-- VIDEO DEL EVENTO -->

                            <!-- FECHA DEL EVENTO -->
                            <v-col cols="10" sm="5" lg="5" style="flex-wrap:wrap" data-aos="fade-left" data-aos-duration="400">
                                <h1 class="headline font-weight-bold text-uppercase">Fecha del evento</h1>
                                <v-row justify="center" align="center" class="fill-height">
                                    <v-col cols="12" sm="12" md="10" class="pt-0">
                                        <h2 v-bind:class="$vuetify.breakpoint.mdAndUp?'display-2':'display-1'" class="font-weight-bold">{{ eventDate[0] }}</h2>
                                        <h2 class="display-12 secondary--text font-weight-bold">{{ eventDate[1] }}</h2>
                                        <h2 v-bind:class="$vuetify.breakpoint.mdAndUp?'display-2':'display-1'" class="font-weight-bold">de {{ eventDate[2] }} {{ eventDate[3] }}</h2>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- FECHA DEL EVENTO -->
                        </v-row>

                        <v-row justify="center" class="grey lighten-3 text-center pb-10" data-aos="fade-up" data-aos-duration="200" v-if="this.sponsors.length>0">
                             <!-- PATROCINADORES -->
                            <v-col cols="12">
                                <h2 class="display-1 font-weight-bold mb-8">
                                    Nuestros patrocinadores
                                </h2>
                            </v-col>
                            <v-col cols="4" md="3" lg="2" v-for="(sponsor, index) in this.sponsors" :key="index" class="mb-5">
                                <v-row justify="center" align="center" class="fill-height">
                                    <img :src="sponsor" class="sponsor-img"/>
                                </v-row>
                            </v-col>
                             <!-- PATROCINADORES -->
                        </v-row>


                        <v-row v-if="currentEvent.modality=='ON_SITE'" data-aos-duration="200">
                            <!-- TARJETA PARA MAPA DEL EVENTO -->
                            <v-col cols="12" class="px-0 py-0" data-aos="fade-up" >
                                <map-card></map-card>
                            </v-col>
                             <!-- TARJETA PARA EL MAPA DEL EVENTO -->
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <w-footer></w-footer>
    </v-container>
</template>
<script>
import mapCard from '@/components/landing/map-card'
import videoCard from '@/components/landing/video-card'
import imageCard from '@/components/landing/image-card'
import wFooter from '@/components/shared/w-footer'
import faqPanel from '@/components/landing/faq-panel'
import { mapState, mapMutations } from 'vuex'
export default {
    components:{
        mapCard,wFooter, faqPanel, videoCard, imageCard
    },
    data(){
        return {
            currentEvent:{},
            eventDate: [],
            sponsors:[],
            sponsorsFiles:[],
            socialMediaIcons:{
                facebook: 'fab fa-facebook-square',
                twitter: 'fab fa-twitter-square',
                linkedin: 'fab fa-linkedin'
            },
            contactDetailsIcons:{
                webSite: 'fas fa-globe',
                tel: 'fas fa-phone',
                email: 'fas fa-envelope'
            },
            amenities:{
                'Estacionamiento':'fas fa-car',
                'Coffee break':'fas fa-coffee',
                'Alimentos':'fas fa-utensils',
                'Constancia':'fas fa-scroll',
                'Aire acondicionado':'fas fa-wind',
                'Cóctel':'fas fa-cocktail',
                'Valet Parking':'fas fa-parking',
            },
        }
    },
    computed:{
        ...mapState('event',['event']),
        ...mapState('user',['user']),
        socialMediaItems(){
            let data = [];
            for(let item in this.currentEvent.socialMedia){
                if(this.currentEvent.socialMedia[item]!='' && item!='youtube' )
                    data.push({ name: item, value: this.currentEvent.socialMedia[item], icon: this.socialMediaIcons[item] })
            }
            return data;
        },
        contactDetailsItems(){
            let data = [];
            for(let item in this.currentEvent.contactDetails){
                if(this.currentEvent.contactDetails[item]!='' && item!='webSite')
                    data.push({ name: item, value: this.currentEvent.contactDetails[item], icon: this.contactDetailsIcons[item] })
            }
            return data;
        },
        getSmallSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:1.2em'
                case 'sm': return 'font-size:1em'
                case 'md': return 'font-size:1em'
                case 'lg': return 'font-size:1.1em'
                case 'xl': return 'font-size:1.3em'
            }
        },
        getSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:1.5em'
                case 'sm': return 'font-size:1.8em'
                case 'md': return 'font-size:2em'
                case 'lg': return 'font-size:2.3em'
                case 'xl': return 'font-size:2.5em'
            }
        },
        getLargeSize(){
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 'font-size:3em'
                case 'sm': return 'font-size:3em'
                case 'md': return 'font-size:4em'
                case 'lg': return 'font-size:6em'
                case 'xl': return 'font-size:7.5em'
            }
        }
    },
    methods:{
        getEventDate(){
            let days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
            let months = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
            const array = this.currentEvent.startDate.split('-');
            let date = new Date(array[0],array[1]-1,array[2]);

            this.eventDate.push( days[ date.getDay() ]);
            this.eventDate.push( date.getDate() );
            this.eventDate.push( months[ date.getMonth() ]);
            this.eventDate.push( date.getFullYear() );
        },
        getVideoLink(){
            if(this.currentEvent.socialMedia.youtube){
                let youtubeId = this.currentEvent.socialMedia.youtube.split("?v=")[1];
                this.currentEvent.socialMedia.youtube = "https://www.youtube.com/embed/" +  youtubeId;
            }
        },
        loadHeader(){
           this.currentEvent.eventImage = URL.createObjectURL(this.currentEvent.eventImage);
        },
        loadSponsors(){
            for(let sponsor of this.sponsorsFiles){
                this.sponsors.push(URL.createObjectURL(sponsor))
            }
        },
    },
    created(){
        this.currentEvent = { ...this.event };
        this.sponsorsFiles = [...this.currentEvent.sponsors];
        this.loadHeader();
        this.loadSponsors();
        this.getEventDate();
        this.getVideoLink();
    },
}
</script>
<style scoped>
    .event-custom-content >>> h1,h2,h3,h4{
        font-weight: 700 !important;
    }
    .event-custom-content >>> blockquote{
        border-left: 4px solid #ccc !important;
        margin-bottom: 5px !important;
        margin-top: 5px !important;
        padding-left: 16px !important;
    }
    .banner-img{
        height: 65vh;
        width: auto;
        flex:none;
        background-size: cover;
    }
    .banner-container{
        height:65vh;
        position: relative;
    }
    .banner-content {
        position: absolute;
        height: 450px;
        bottom: -225px;
        transition: 0.13s all ease-in-out;
    }
    .event-content{
        margin-top:250px;
    }
    .sponsor-img{
        filter: grayscale(1);
        height: auto;
        max-height: 100px;
        width: 100%;
        max-width: 130px;
        transition: 0.15s all ease-in-out;
    }
    .sponsor-img:hover{
        transform: scale(1.07)
    }

    @media (max-width: 599px) {
        .sponsor-img{
            max-height: 60px;
            max-width: 80px;
        }
        .banner-img{
            display:none;
        }
        .banner-container{
            height:520px;
            position: relative;
        }
        .banner-content {
            position: absolute;
            height: 550px;
            bottom: 0px;
            transition: 0.13s all ease-in-out;
        }
        .event-content{
            margin-top:50px;
        }
        .event-custom-content >>> h1{
            font-size:1.05em !important;
        }
        .event-custom-content >>> h2{
            font-size:1em !important;
        }
        .event-custom-content >>> h3{
            font-size:0.95em !important;
        }
    }

    @media (min-width: 600px) and (max-width: 959px)  {
        .sponsor-img{
            max-height: 70px;
            max-width: 100px;
        }
        .banner-img, .banner-container{
            height:400px;
        }
        .banner-content {
            position: absolute;
            height: 500px;
            bottom: -255px;
            transition: 0.13s all ease-in-out;
        }
        .event-content{
            margin-top:300px;
        }
        .event-custom-content >>> h1{
            font-size:1em !important;
        }
        .event-custom-content >>> h2{
            font-size:0.95em !important;
        }
        .event-custom-content >>> h3{
            font-size:0.9em !important;
        }
    }

    @media (min-width: 960px) and (max-width: 1263px)  {
        .sponsor-img{
            max-height: 85px;
            max-width: 100px;
        }
        .banner-img, .banner-container{
            height:400px;
        }
        .banner-content {
            position: absolute;
            height: 430px;
            bottom: -215px;
            transition: 0.13s all ease-in-out;
        }
        .event-content{
            margin-top:250px;
        }
        .event-custom-content >>> h1{
            font-size:1.2em !important;
        }
        .event-custom-content >>> h2{
            font-size:1em !important;
        }
        .event-custom-content >>> h3{
            font-size:0.9em !important;
        }
    }

    @media (min-width: 1264px) and (max-width: 1903px)  {
        .sponsor-img{
            max-height: 100px;
            max-width: 120px;
        }
        .event-custom-content >>> h1{
            font-size:1.28em !important;
        }
        .event-custom-content >>> h2{
            font-size:1.2em !important;
        }
        .event-custom-content >>> h3{
            font-size:1em !important;
        }
    }

    @media (min-width: 1903px)  {
        .sponsor-img{
            max-height: 100px;
            max-width: 120px;
        }
        .event-custom-content >>> h1{
            font-size:1.5em !important;
        }
        .event-custom-content >>> h2{
            font-size:1.2em !important;
        }
        .event-custom-content >>> h3{
            font-size:1em !important;
        }
    }

</style>